<script>
  import { onMount } from 'svelte';

  export let value;
  export let preview = false;
  export let disabled = false;
  export let width = '320px';
  export let height = '180px';
  export let lang = undefined;

  let previewInternal = preview;

  let input;
  let files;
  let highlight = false;
  let mounted = false;

  onMount(() => {
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      input.addEventListener(eventName, event => {
        event.preventDefault();
        event.stopPropagation();
      });
    });

    mounted = true;
  });

  $: if (files) value = files[0];

  $: if (!disabled && mounted) input.addEventListener('drop', event => { value = [...event.dataTransfer.files][0]; });

  $: if (value) {
    // eslint-disable-next-line no-undef
    const fileReader = new FileReader();

    fileReader.readAsDataURL(value);
    fileReader.onloadend = () => {
      previewInternal = fileReader.result;
    };
  }

  const i18n = {
    uploadPhoto: {
      cs: 'Nahrajte fotografii nebo ji sem přetáhněte.',
      en: 'Upload a photo or drag and drop it here.',
    },
  };
</script>

<div class='photo-drag-and-drop' style='--photo-drag-and-drop-width: {width}; --photo-drag-and-drop-height: {height};'>
  {#if previewInternal}
    <img class='photo-drag-and-drop-preview' src={previewInternal} alt='Drag and drop preview'
      class:photo-drag-and-drop-preview-disabled={disabled}/>
  {/if}

  <label class='photo-drag-and-drop-input' bind:this={input}
    class:photo-drag-and-drop-input-highlight={highlight && !disabled}
    class:photo-drag-and-drop-input-disabled={disabled}
    class:photo-drag-and-drop-input-preview={previewInternal}
    on:dragenter={() => { highlight = true; }} on:dragover={() => { highlight = true; }}
    on:dragleave={() => { highlight = false; }} on:drop={() => { highlight = false; }}>

    <input type='file' accept='image/png, image/jpeg' bind:files={files} disabled={disabled}>

    <div class='photo-drag-and-drop-input-box'>
      <div class='photo-drag-and-drop-input-box-content'>
        <div class='photo-drag-and-drop-input-box-content-icon material-icons'>
          upload
        </div>

        <div class='photo-drag-and-drop-input-box-content-text'>
          {value ? value.name : i18n.uploadPhoto[lang]}
        </div>
      </div>
    </div>
  </label>
</div>

<style>
  .photo-drag-and-drop {
    display: flex;
    justify-content: space-between;
  }

  .photo-drag-and-drop-preview {
    width: var(--photo-drag-and-drop-width);
    height: var(--photo-drag-and-drop-height);

    border-radius: 5px;

    object-fit: cover;
  }

  .photo-drag-and-drop-preview-disabled {
    filter: grayscale(100%);
  }

  .photo-drag-and-drop-input {
    display: block;

    width: 100%;
    height: var(--photo-drag-and-drop-height);

    padding: 20px;

    box-sizing: border-box;
    border: 2px dashed var(--grey-5);
    border-radius: 5px;

    cursor: pointer;
    user-select: none;

    transition: background 0.25s ease-in-out, border-color 0.25s ease-in-out;
  }

  .photo-drag-and-drop-input:hover {
    background: var(--grey-1);
  }

  .photo-drag-and-drop-input-highlight {
    border-color: var(--grey-9);
  }

  .photo-drag-and-drop-input-disabled {
    background: var(--grey-1);
    color: var(--grey-5);

    cursor: default;
  }

  .photo-drag-and-drop-input-preview {
    width: calc(100% - var(--photo-drag-and-drop-width) - 40px);
  }

  .photo-drag-and-drop-input input {
    display: none;
  }

  .photo-drag-and-drop-input-box {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
  }

  .photo-drag-and-drop-input-box-content-icon {
    width: 100%;

    text-align: center;

    font-size: 64px;

    color: var(--grey-5);
  }

  .photo-drag-and-drop-input-box-content-text {
    text-align: center;

    font-size: 12px;
    font-weight: 550;

    color: var(--grey-9);
  }

  :global(body.dark) .photo-drag-and-drop-input {
    border: 2px dashed var(--grey-6);
  }

  :global(body.dark) .photo-drag-and-drop-input:hover {
    background: var(--grey-8);
  }

  :global(body.dark) .photo-drag-and-drop-input-highlight {
    border-color: var(--grey-4);
  }

  :global(body.dark) .photo-drag-and-drop-input-disabled {
    background: var(--grey-8);
    color: var(--grey-6);
  }

  :global(body.dark) .photo-drag-and-drop-input-box-content-icon {
    color: var(--grey-6);
  }

  :global(body.dark) .photo-drag-and-drop-input-box-content-text {
    color: var(--grey-4);
  }

  @media only screen and (max-width: 750px) {
    .photo-drag-and-drop-preview {
      width: 240px;
    }

    .photo-drag-and-drop-input-preview {
      width: calc(100% - 280px);
    }
  }

  @media only screen and (max-width: 600px) {
    .photo-drag-and-drop-preview {
      width: 160px;
    }

    .photo-drag-and-drop-input-preview {
      width: calc(100% - 200px);
    }
  }

  @media only screen and (max-width: 450px) {
    .photo-drag-and-drop-preview {
      width: 80px;
    }

    .photo-drag-and-drop-input-preview {
      width: calc(100% - 120px);
    }
  }
</style>
